module.exports = __webpack_public_path__ + "static/media/linkedin.e8ae2206.svg";


//////////////////
// WEBPACK FOOTER
// ./public/assets/linkedin.svg
// module id = 1293
// module chunks = 0